/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { css, withMemo } from 'fierry/react.old';

import Placement from 'galax/react/map/hex/placement';

import Background from 'galax/react/map/hex/background';
import Borders from 'galax/react/map/hex/borders';

import Unit from 'galax/react/map/entity/unit';


const ExternalStyle = ({ hexGeometry }) => css`

  stroke: var(--svg-always-other);

  stroke-width: ${hexGeometry.getDockBorderWidth()};
`;


const ZoneStyle = ({ hexGeometry, borderGeometry }) => css`

  stroke: var(--svg-always-other);

  stroke-width: ${hexGeometry.getDockBorderWidth()};
  stroke-dasharray: ${borderGeometry.getDasharray(3)};
`;


const PlatformBackground = ({ containerRef, ...props }) =>
(
  <Placement {...props} containerRef = {containerRef} index = {0} >

    <Background {...props} secondaryColor
      opacityValue = {0.1}
    />

    <Borders {...props}
      externalStyle = {ExternalStyle}
      zoneStyle = {ZoneStyle}
    />

  </Placement>
);


const PlatformForeground = ({ containerRef, ...props }) =>
(
  <Placement {...props} containerRef = {containerRef} index = {2} >

      <Unit {...props} />

  </Placement>
);


const Component = (props) =>
(
  <>
    <PlatformBackground {...props} />
    <PlatformForeground {...props} />
  </>
)

export default withMemo(props =>
{
  return <Component {...props} location = {props.platform.getLocation()} />;
});
